import React from 'react'
import AdminHome from '../Components/AdminHome/AdminHome'
import NavAdmin from '../Components/AdminNav/NavAdmin'

function HomePanel() {
  return (
    <div>
        <NavAdmin></NavAdmin>
        <AdminHome></AdminHome>
    </div>
  )
}

export default HomePanel